import { useMatch } from 'react-router';
import { Chain } from '@ankr.com/chains-list';

import { AccountPermission } from 'modules/permissions/constants';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useCanAddNetwork } from 'modules/wallet/hooks/useCanAddNetwork';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';
import { projectsRoutesConfig } from 'domains/projects/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';

export const useHasAddToWalletItem = (chain: Chain) => {
  const { isFreemium } = useAccountStatus();

  const { isLoggedIn } = useAuth();

  const canAddNetwork = useCanAddNetwork();

  const hasBillingRoleAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  const hasToUpgradeButNoAccess =
    !!chain.premiumOnly && isFreemium && !hasBillingRoleAccess;

  const isProjectPage = Boolean(useMatch(projectsRoutesConfig.project.path));

  const isHidden =
    !canAddNetwork || hasToUpgradeButNoAccess || (isLoggedIn && !isProjectPage);

  return !isHidden;
};
